import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Modal from '@trileuco/triskel-react-ui/components/ui/Modal'
import { useAuth } from '@trileuco/triskel-react-ui/modules/auth/useAuth'
import { loadYepCodeSDK } from 'utils/yepcode'

const ToReportGenerationModal = ({ isOpen, close }) => {
  const [sdkLoaded, setSdkLoaded] = useState(false)
  const {
    keycloak: { token: accessToken, userInfo }
  } = useAuth()

  useEffect(() => {
    if (isOpen && !sdkLoaded) {
      loadYepCodeSDK()
        .then(() => {
          setSdkLoaded(true)
        })
        .catch((error) => {
          console.error('Failed to load YepCode SDK:', error)
        })
    }
  }, [isOpen, sdkLoaded])

  useEffect(() => {
    if (isOpen && sdkLoaded && window.YepCode) {
      window.YepCode.initForm('#report-generation-form', {
        team: 'balaena',
        process: '9e4dc793-63a7-4d7e-85ec-59977a1ce94b',
        options: {
          theme: 'light'
        },
        defaultValues: {
          accessToken,
          emailTo: userInfo.email,
          fromDate: new Date(new Date().setDate(new Date().getDate() - 1))
            .toISOString()
            .split('T')[0],
          toDate: new Date().toISOString().split('T')[0]
        }
      })
    }
  }, [isOpen, sdkLoaded, accessToken, userInfo])

  return (
    <Modal
      name="ToReportGenerationModal"
      className="ToReportGenerationModal"
      isOpen={isOpen}
      onClose={close}
      body={<div id="report-generation-form"></div>}
    />
  )
}

ToReportGenerationModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func
}

ToReportGenerationModal.displayName = 'ToReportGenerationModal'

export default ToReportGenerationModal
